"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterHeader = void 0;
const filter_bar_1 = require("client/components/filter-bar");
const switch_1 = require("client/components/material/switch");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./filter-header.less");
let FilterHeader = class FilterHeader extends react_1.Component {
    render() {
        const { label, switchChecked, switchChecked2, switchLabel = "", switchLabel2 = "", title, withSwitch, withSwitch2, withDatePicker, callBack, handleToggle, handleToggle2, handleToggle3, countFilter, hideAdvancedFilter, filterText = "", filterDate = "", decoration = "initial" // B-104
         } = this.props;
        // const isMtop= decoration?.top===undefined? "unset" : decoration.top // 
        const isMtop = (decoration === null || decoration === void 0 ? void 0 : decoration.top) && decoration.marginTop; // B-104;
        const position = (decoration === null || decoration === void 0 ? void 0 : decoration.top) && decoration.position;
        const isTop = (decoration === null || decoration === void 0 ? void 0 : decoration.top) && decoration.top;
        const zIndex = (decoration === null || decoration === void 0 ? void 0 : decoration.top) && decoration.zIndex;
        return (
        // B-104
        //  <div className="filter-header" style={{marginTop:isMtop}}> 
        React.createElement("div", { className: "filter-header", style: { position: position, top: isTop, marginTop: isMtop, zIndex: zIndex } },
            React.createElement("div", { className: "filter-header__content" },
                React.createElement(filter_bar_1.FilterBar, { label: label, title: title !== null && title !== void 0 ? title : "", withDatePicker: withDatePicker, countFilter: countFilter, hideAdvancedFilter: hideAdvancedFilter, filterText: filterText, filterDate: filterDate, callBack: callBack, handleToggle3: handleToggle3 },
                    withSwitch && (React.createElement("div", { className: "filter-header__action" },
                        React.createElement(switch_1.MaterialSwitch, { label: switchLabel, value: "true", checked: switchChecked, onChange: handleToggle }))),
                    withSwitch2 && (React.createElement("div", { className: "filter-header__action" },
                        React.createElement(switch_1.MaterialSwitch, { label: switchLabel2, value: "true", checked: switchChecked2, onChange: handleToggle2 })))))));
    }
};
FilterHeader = __decorate([
    mobx_react_1.observer
], FilterHeader);
exports.FilterHeader = FilterHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/filter-header/filter-header.tsx
// module id = 3425
// module chunks = 0